<template>
	<div v-if="data" :class="['sub-values', {'inline': none}]">
		<div class="sub-value clickable" @click="$emit('click')">
			<div class="label">{{ none ? typeLabel : 'Möglich' }}</div>
			<div v-if="!none">{{ typeLabel }}</div>
		</div>
		<div v-if="startEligible && data.start" class="sub-value clickable" @click="$emit('click')">
			<div class="label">Ab wann</div>
			<div>{{ start }}</div>
		</div>
		<div v-if="degreeEligible" class="sub-value clickable" @click="$emit('click')">
			<div class="label">Ausmaß</div>
			<div>{{ degree }}</div>
		</div>
	</div>
</template>

<script>
import * as HomeOffice from "@/helper/job-profile/HomeOffice"
import _ from "lodash";

export default {
	props: {
		data: {
			type: Object,
			required: false
		}
	},

	computed: {
		typeLabel ()
		{
			return HomeOffice.getTypeLabel(this.data.type);
		},
		yes ()
		{
			return this.data.type === HomeOffice.TYPE_YES;
		},
		none ()
		{
			return this.data.type === HomeOffice.TYPE_NO;
		},
		startEligible ()
		{
			return this.yes;
		},
		start ()
		{
			return _
				.map(this.data.start, key => HomeOffice.getStartLabel(key))
				.join(' | ');
		},
		degreeEligible ()
		{
			return !this.none && this.data.degree;
		},
		degree ()
		{
			if (this.data.degree === HomeOffice.DEGREE_ALL)
			{
				return HomeOffice.getDegreeLabel(HomeOffice.DEGREE_ALL);
			}

			return HomeOffice.getDegreeDaysLabel(this.data.degreeDays);
		}
	}
}
</script>
